import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterOpcoesFiltro() {
        return axiosJwt
            .get(`${api}/sgtec/uabs/relatorios/opcoesfiltros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatorioFaturamentoEtapas(filtro) {
        let url = `${api}/sgtec/faturamento-etapas?dataInicial=${filtro.dataInicial ? filtro.dataInicial : ''
            }&dataFinal=${filtro.dataFinal ? filtro.dataFinal : ''
            }&cnpjFornecedor=${filtro.fornecedor ? filtro.fornecedor : ''
            }&codgestor=${filtro.gestor ? filtro.gestor : ''
            }&unidade=${filtro.unidade ? filtro.unidade : ''}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}